import { call, put } from "redux-saga/effects";
import { AdminUserResponse, TransactionsResponse } from "reduxStore/dataTypes";
import { fetchAdminTransactions, fetchAdminUsers } from "services/apiService";
import {
  adminTransactionsFailure,
  adminTransactionsRequest,
  adminTransactionsSuccess,
} from "../reducers/adminTransactionsReducer";

function* adminTransactionsSaga(
  action: any
): Generator<any, void, TransactionsResponse | any> {
  try {
    const { payload } = action;
    yield put(adminTransactionsRequest());
    const response = yield call(fetchAdminTransactions, payload);
    yield put(adminTransactionsSuccess(response.data));
  } catch (error: any) {
    if (error && error.response) {
      yield put(adminTransactionsFailure(error.response));
    } else {
      yield put(adminTransactionsFailure(error.message));
    }
  }
}

export default adminTransactionsSaga;
